function FeedIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 9.75C9.206 9.75 7.75 11.206 7.75 13C7.75 14.794 9.206 16.25 11 16.25C12.794 16.25 14.25 14.794 14.25 13C14.25 11.206 12.794 9.75 11 9.75ZM11 11.25C11.966 11.25 12.75 12.034 12.75 13C12.75 13.966 11.966 14.75 11 14.75C10.034 14.75 9.25 13.966 9.25 13C9.25 12.034 10.034 11.25 11 11.25Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10.25C16.758 10.25 15.75 11.258 15.75 12.5C15.75 13.742 16.758 14.75 18 14.75C19.242 14.75 20.25 13.742 20.25 12.5C20.25 11.258 19.242 10.25 18 10.25ZM18 11.75C18.414 11.75 18.75 12.086 18.75 12.5C18.75 12.914 18.414 13.25 18 13.25C17.586 13.25 17.25 12.914 17.25 12.5C17.25 12.086 17.586 11.75 18 11.75Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 10.25C2.758 10.25 1.75 11.258 1.75 12.5C1.75 13.742 2.758 14.75 4 14.75C5.242 14.75 6.25 13.742 6.25 12.5C6.25 11.258 5.242 10.25 4 10.25ZM4 11.75C4.414 11.75 4.75 12.086 4.75 12.5C4.75 12.914 4.414 13.25 4 13.25C3.586 13.25 3.25 12.914 3.25 12.5C3.25 12.086 3.586 11.75 4 11.75Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.25 21V19.5C16.25 17.981 15.019 16.75 13.5 16.75H8.5C6.981 16.75 5.75 17.981 5.75 19.5V21C5.75 21.414 6.086 21.75 6.5 21.75C6.914 21.75 7.25 21.414 7.25 21V19.5C7.25 18.81 7.81 18.25 8.5 18.25H13.5C14.19 18.25 14.75 18.81 14.75 19.5V21C14.75 21.414 15.086 21.75 15.5 21.75C15.914 21.75 16.25 21.414 16.25 21Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.75 20V18.5C21.75 16.981 20.519 15.75 19 15.75C17.798 15.75 16.5 15.75 16.5 15.75C16.086 15.75 15.75 16.086 15.75 16.5C15.75 16.914 16.086 17.25 16.5 17.25H19C19.69 17.25 20.25 17.81 20.25 18.5V20C20.25 20.414 20.586 20.75 21 20.75C21.414 20.75 21.75 20.414 21.75 20Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 20V18.5C1.75 17.81 2.31 17.25 3 17.25H5.5C5.914 17.25 6.25 16.914 6.25 16.5C6.25 16.086 5.914 15.75 5.5 15.75C5.5 15.75 4.202 15.75 3 15.75C1.481 15.75 0.25 16.981 0.25 18.5V20C0.25 20.414 0.586 20.75 1 20.75C1.414 20.75 1.75 20.414 1.75 20Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.25 5.5V2C16.25 1.033 15.466 0.25 14.5 0.25C12.768 0.25 9.232 0.25 7.5 0.25C6.534 0.25 5.75 1.033 5.75 2V5.5C5.75 6.467 6.534 7.25 7.5 7.25H8.75L10.55 8.6C10.817 8.8 11.183 8.8 11.45 8.6L13.25 7.25H14.5C15.466 7.25 16.25 6.467 16.25 5.5ZM14.75 2V5.5C14.75 5.638 14.638 5.75 14.5 5.75H13C12.838 5.75 12.68 5.803 12.55 5.9L11 7.062L9.45 5.9C9.32 5.803 9.162 5.75 9 5.75H7.5C7.362 5.75 7.25 5.638 7.25 5.5V2C7.25 1.862 7.362 1.75 7.5 1.75H14.5C14.638 1.75 14.75 1.862 14.75 2Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.331 8.573L16.516 9.573C16.796 9.809 17.204 9.809 17.484 9.573L19.052 8.25H20C20.967 8.25 21.75 7.467 21.75 6.5V3C21.75 2.033 20.967 1.25 20 1.25H18C17.586 1.25 17.25 1.586 17.25 2C17.25 2.414 17.586 2.75 18 2.75H20C20.138 2.75 20.25 2.862 20.25 3V6.5C20.25 6.638 20.138 6.75 20 6.75H18.778C18.601 6.75 18.429 6.813 18.294 6.927L17 8.019L16.298 7.427C15.982 7.16 15.509 7.2 15.242 7.516C14.975 7.833 15.015 8.306 15.331 8.573Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.702 7.427L5 8.019L3.706 6.927C3.571 6.813 3.399 6.75 3.222 6.75H2C1.862 6.75 1.75 6.638 1.75 6.5V3C1.75 2.862 1.862 2.75 2 2.75H4C4.414 2.75 4.75 2.414 4.75 2C4.75 1.586 4.414 1.25 4 1.25H2C1.033 1.25 0.25 2.033 0.25 3V6.5C0.25 7.467 1.033 8.25 2 8.25H2.948L4.516 9.573C4.796 9.809 5.204 9.809 5.484 9.573L6.669 8.573C6.985 8.306 7.025 7.833 6.758 7.516C6.491 7.2 6.018 7.16 5.702 7.427Z"
        fill="#1C274"
        className="fill"
      />
    </svg>
  );
}

export default FeedIcon;
